/**
 * Public API scope vocabulary — shared by the apiKey tRPC router (validation),
 * the /v1 auth middleware (enforcement), and the Developer UI (scope checkboxes).
 * Additively evolvable: add new scopes here; never remove one (frozen contract).
 */
export const ALLOWED_SCOPES = [
  'events:read',
  'topology:read',
  'doors:control',
  'cardholders:read',
  'cardholders:write',
  'access_levels:read',
  'access_levels:write',
] as const;

export type ApiScope = (typeof ALLOWED_SCOPES)[number];
